<div class="view-container">
<mat-card class="medicine-create-card">
  <div class="medicine-create-card__header">
    <div class="medicine-create-card__title-row">
      <div class="medicine-create-card__icon">
        <mat-icon>medication</mat-icon>
      </div>
      <div>
        <h1 class="medicine-create-card__title">
          New medicine
          @if (createdMedicine) {
            <span> — {{ createdMedicine.name }}</span>
          }
        </h1>
        <p class="medicine-create-card__subtitle">Capture medicine, dosage type, and package details</p>
      </div>
    </div>
  </div>
  <mat-stepper linear #stepper class="medicine-create-card__stepper">
    <mat-step [editable]="creatingMedicineIsEditable" [stepControl]="medicineForm">
      <ng-template matStepLabel>New medicine active</ng-template>
      <form autocomplete="off" [formGroup]="medicineForm">
        <div class="row">
          <div class="col-md-6">

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Name</mat-label>
                <input required formControlName="name" type="text" matInput>
                @if (medicineForm.get('name')?.invalid) {
                  <mat-error>
                    Name is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Barcode prefix</mat-label>
                <input required formControlName="barcodePrefix" type="text" matInput>
                  @if (medicineForm.get('barcodePrefix')?.invalid) {
                    <mat-error>
                      Barcode prefix is invalid
                    </mat-error>
                  }
                </mat-form-field>
              </p>

            </div>

            <div class="col-md-6">

              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Active ingredient</mat-label>
                  <input required formControlName="activeIngredient" type="text" matInput>
                    @if (medicineForm.get('activeIngredient')?.invalid) {
                      <mat-error>
                        Active ingredient is invalid
                      </mat-error>
                    }
                  </mat-form-field>
                </p>

                <p>
                  <mat-form-field appearance="outline">
                    <mat-label>Active ingredient nappy code</mat-label>
                    <input formControlName="activeIngredientNappyCode" type="text" matInput>
                      @if (medicineForm.get('activeIngredientNappyCode')?.invalid) {
                        <mat-error>
                          Active ingredient nappy code is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>

                </div>
              </div>

              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Schedule status</mat-label>
                  <mat-select required formControlName="scheduleStatus">
                    @for (status of scheduleStatuses; track status) {
                      <mat-option [value]="status">
                        {{status}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (medicineForm.get('scheduleStatus')?.invalid) {
                    <mat-error>
                      Schedule status is invalid
                    </mat-error>
                  }
                </mat-form-field>
              </p>

              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Description</mat-label>
                  <textarea required formControlName="description" matInput></textarea>
                  @if (medicineForm.get('description')?.invalid) {
                    <mat-error>
                      Description is invalid
                    </mat-error>
                  }
                </mat-form-field>
              </p>

            </form>
            <div class="medicine-create-card__footer">
              <button type="button" [disabled]="!medicineForm.valid" (click)="createMedicine()" mat-flat-button color="primary" class="medicine-create-card__btn--primary">
                Next<mat-icon iconPositionEnd>chevron_right</mat-icon>
              </button>
            </div>
          </mat-step>
          <mat-step [editable]="creatingMedicineDosageTypeIsEditable" [stepControl]="medicineDosageTypeForm">
            <ng-template matStepLabel>Medicine active dosage type</ng-template>
            <form autocomplete="off" [formGroup]="medicineDosageTypeForm">
              <div class="row">
                <div class="col-md-6">

                  <p>
                    <core-dosage-type-search-field
                      [control]="medicineDosageTypeForm.controls['dosageType']"
                      [dosageUnits]="dosageUnits"
                      (dosageTypeCreated)="onDosageTypeCreated($event)">
                    </core-dosage-type-search-field>
                  </p>

                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Display name</mat-label>
                      <input required type="text" formControlName="additionalInformation" matInput>
                        @if (medicineDosageTypeForm.get('additionalInformation')?.invalid) {
                          <mat-error>
                            Display name is invalid
                          </mat-error>
                        }
                      </mat-form-field>
                    </p>

                  </div>

                  <div class="col-md-6">
                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Strength</mat-label>
                        <input required formControlName="dosageStrength" type="text" matInput>
                          @if (medicineDosageTypeForm.get('dosageStrength')?.invalid) {
                            <mat-error>
                              Strength is invalid
                            </mat-error>
                          }
                        </mat-form-field>
                      </p>


                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Active</mat-label>
                          <mat-select formControlName="isActive">
                            <mat-option [value]="true">Yes</mat-option>
                            <mat-option [value]="false">No</mat-option>
                          </mat-select>
                          @if (medicineDosageTypeForm.get('isActive')?.invalid) {
                            <mat-error>
                              Active is invalid
                            </mat-error>
                          }
                        </mat-form-field>
                      </p>

                    </div>
                  </div>

                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Usage instructions</mat-label>
                      <textarea required formControlName="usageInstructions" matInput></textarea>
                      @if (medicineDosageTypeForm.get('usageInstructions')?.invalid) {
                        <mat-error>
                          Usage instructions is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>

                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Storage directions</mat-label>
                      <textarea required formControlName="storageDirections" matInput></textarea>
                      @if (medicineDosageTypeForm.get('storageDirections')?.invalid) {
                        <mat-error>
                          Storage directions is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>

                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Special instructions</mat-label>
                      <textarea formControlName="specialInstructions" matInput></textarea>
                      @if (medicineDosageTypeForm.get('specialInstructions')?.invalid) {
                        <mat-error>
                          Special instructions is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>

                </form>
                <div class="medicine-create-card__footer">
                  <button type="button" mat-stroked-button class="medicine-create-card__btn me-2" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon> Back
                  </button>
                  <button type="button" mat-flat-button [disabled]="!medicineDosageTypeForm.valid" color="primary" class="medicine-create-card__btn--primary"
                    (click)="createMedicineDosageType()">
                    Next<mat-icon iconPositionEnd>chevron_right</mat-icon>
                  </button>
                </div>
              </mat-step>
              <mat-step [stepControl]="medicineDosagePackageTypeForm">
                <ng-template matStepLabel>Medicine package types</ng-template>
                <form [formGroup]="medicineDosagePackageTypeForm">
                  <div class="row">

                    <p class="col-md-6">
                      <mat-form-field appearance="outline">
                        <mat-label>Label name</mat-label>
                        <input required formControlName="labelName" type="text" matInput>
                        @if (medicineDosagePackageTypeForm.get('labelName')?.invalid) {
                          <mat-error>
                            Label name is invalid {{labelNameExceeds25Chars ? ": Max 25 characters allowed" : ""}}
                          </mat-error>
                        }
                        <mat-hint>Maximum of 25 characters</mat-hint>
                      </mat-form-field>
                    </p>

                    <p class="col-md-6">
                      <mat-form-field appearance="outline">
                        <mat-label>Price</mat-label>
                        <input required formControlName="price" type="number" matInput>
                        @if (medicineDosagePackageTypeForm.get('price')?.invalid) {
                          <mat-error>
                            Price is invalid
                          </mat-error>
                        }
                      </mat-form-field>
                    </p>

                    <p class="col-md-6">
                      <core-package-type-search-field
                        [control]="medicineDosagePackageTypeForm.controls['packageType']"
                        (packageTypeCreated)="onPackageTypeCreated($event)">
                      </core-package-type-search-field>
                    </p>

                    <p class="col-md-6">
                      <mat-form-field appearance="outline">
                        <mat-label>Quantity</mat-label>
                        <input required formControlName="containedQuantity" type="number" step="0.01" matInput>
                          <span matSuffix>{{currentDosageUnit ? currentDosageUnit.unit : "-"}}</span>
                          @if (medicineDosagePackageTypeForm.get('containedQuantity')?.invalid) {
                            <mat-error>
                              Quantity is invalid
                            </mat-error>
                          }
                        </mat-form-field>
                      </p>

                    <p class="col-md-6">
                      <mat-form-field appearance="outline">
                        <mat-label>Units per pack</mat-label>
                        <input required formControlName="unitsPerPack" type="number" min="1" step="1" matInput>
                        <mat-hint>e.g. 1 for a 5ml bottle, 5 for a 5 × 1ml pack</mat-hint>
                        @if (medicineDosagePackageTypeForm.get('unitsPerPack')?.invalid) {
                          <mat-error>
                            Units per pack must be 1 or more
                          </mat-error>
                        }
                      </mat-form-field>
                    </p>

                    <p class="col-md-6">
                      <mat-form-field appearance="outline">
                        <mat-label>Minimum order qty</mat-label>
                        <input formControlName="minOrderQty" type="number" min="1" step="1" matInput>
                        <mat-hint>Leave empty if there is no minimum</mat-hint>
                      </mat-form-field>
                    </p>

                    <p class="col-md-6">
                      <core-sage-item-code-field></core-sage-item-code-field>
                    </p>

                    </div>
                  </form>

                  <button mat-stroked-button [disabled]="!medicineDosagePackageTypeForm.valid"
                    (click)="createMedicineDosagePackageType()">
                    <mat-icon>add</mat-icon> Add package type
                  </button>

                  <!--List out the package types :)-->
                  @if (createdMedicineDosageType && createdMedicine) {
                    <core-medicine-dosage-package-type-list [dosageUnit]="currentDosageUnit" (onUpdated)="onDosagePackageTypesUpdated($event)"
                      [medicineDosageTypeId]="createdMedicineDosageType.id" [packageTypes]="packageTypes"
                      [medicineId]="createdMedicine.id" [medicineDosagePackageTypes]="medicineDosagePackageTypes">
                    </core-medicine-dosage-package-type-list>
                  }
                  <div class="medicine-create-card__footer">
                    <button type="button" mat-flat-button (click)="redirect()" color="primary" class="medicine-create-card__btn--primary">
                      <mat-icon>done</mat-icon> Done
                    </button>
                  </div>
                </mat-step>
              </mat-stepper>
            </mat-card>
</div>
